<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :url="url"
                      :operate="[]"
                      :form-fields="formFields"
                      :permission="permission"
                      :searchs="searchs"
                      ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "WithdrawSetting",
        components: {CommonTable},
        data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }],
                permission:{
                    add: 'withdrawSetting:add',
                    update: 'withdrawSetting:update',
                    delete: 'withdrawSetting:delete',
                    deleteBatch: 'withdrawSetting:deleteBatch'
                },
                url: {
                    get: '/withdrawSetting/listByCondition',
                    add: '/withdrawSetting/add',
                    update: '/withdrawSetting/update',
                    delete: '/withdrawSetting/delete/',
                    delete_batch: '/withdrawSetting/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'minAmount',
                    label: '最小累充额度',
                    show: true,
                    width: '',
                }, {
                    field: 'maxAmount',
                    label: '最大累充额度',
                    show: true,
                    width: '',
                }, {
                    field: 'ratio',
                    label: '提款比例',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    width: '',
                }, {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加提现配置',
                    updateTitle: '修改提现配置',
                    labelWidth: '90px',
                    model: [{
                        field: 'agentId',
                        label: '代理：',
                        type: 'select',
                        placeholder: '请选择代理',
                        rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'minAmount',
                        label: '最小额度',
                        type: 'input',
                        placeholder: '最小累充额度(USDT)',
                        rules:[{
                            message: '请输入最小累充额度', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'maxAmount',
                        label: '最大额度',
                        type: 'input',
                        placeholder: '最大累充额度(USDT)',
                        rules:[{
                            message: '请输入最大累充额度', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'ratio',
                        label: '提款比例',
                        type: 'money',
                        placeholder: '提款比例(%)',
                        rules:[{
                            message: '请输入提款比例(%)', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'code',
                        label: '验证码',
                        type: 'input',
                        placeholder: '谷歌验证码',
                        rules:[{
                            message: '请输入谷歌验证码', trigger: 'blur', required: true
                        }],
                        add: false,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
